const environment = process.env.TW_ENV_TYPE || process.env.NODE_ENV || 'dev';
const isProduction = environment === 'prod' || environment === 'production';
const metricsServerPort = process.env.METRICS_SERVER_PORT || 10005;
const connectWebsocketsPort = process.env.CONNECT_WEBSOCKETS_PORT || 3050;
const isTest = process.env.NODE_ENV === 'test';
const segmentWriteKeyDEV = 'MDPs3JBRp9U3xv9ikZs1SAnBQbrGG7NS';
const segmentWriteKey = isProduction
  ? process.env.SEGMENT_WRITE_KEY
  : process.env.SEGMENT_WRITE_KEY || segmentWriteKeyDEV;
const mixpanelDevToken = '35e7da3d173048c962dcbd28c5ddbf7a';
const mixpanelProjectToken = process.env.MIXPANEL_PROJECT_TOKEN || mixpanelDevToken;
const hubSpotDevID = '147536686';
const hubSpotId = process.env.HUB_SPOT_TRACKING_CODE_ID || hubSpotDevID;
// TW_ENV_NAME is used specifically for Datadog RUM environment tagging
const twEnvName = process.env.TW_ENV_NAME || environment;
// APPLICATION_VERSION is used specifically for Datadog RUM version tagging
const applicationVersion = process.env.APPLICATION_VERSION;
// Datadog RUM application id and client token. These are public by design (they
// ship to the browser), but they are env-driven so they can be repointed at a
// different RUM application without a code deploy.
const datadogApplicationIdDefault = '83467a5f-d8c3-45d1-8749-a0db401d211c';
const datadogClientTokenDefault = 'pube59739aa878c52941a48f10a06d5aeb5';
const datadogApplicationId = process.env.DATADOG_APPLICATION_ID || datadogApplicationIdDefault;
const datadogClientToken = process.env.DATADOG_CLIENT_TOKEN || datadogClientTokenDefault;
// DATADOG_SESSION_SAMPLE_RATE is used for controlling DataDog RUM session sampling
const datadogSessionSampleRate = Number.parseInt(process.env.DATADOG_SESSION_SAMPLE_RATE || '5');

const datadogSessionReplaySampleRate = Number.parseInt(
  process.env.DATADOG_SESSION_REPLAY_SAMPLE_RATE || '0',
);

const googlePlacesApiKey = process.env.GOOGLE_PLACES_API_KEY;

const productFruitsWorkspaceId = isProduction
  ? 'BJvflQeTJkQf1OQu' // Treatwell Connect - PROD
  : 'ReiNaAkTf3M0J9nS'; // Treatwell Connect - DEV01

module.exports = {
  environment,
  isProduction,
  isTest,
  connectWebsocketsPort,
  metricsServerPort,
  segmentWriteKey,
  twEnvName,
  applicationVersion,
  datadogApplicationId,
  datadogClientToken,
  datadogSessionSampleRate,
  datadogSessionReplaySampleRate,
  mixpanelProjectToken,
  googlePlacesApiKey,
  hubSpotId,
  productFruitsWorkspaceId,
};
